import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  id: number;
  /** Full replacement lists of shared Division/Team ids (sharing panel). */
  additional_divisions?: number[];
  additional_teams?: number[];
}
export const useUpdateMandate = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.patch(
      `${env.verifyServiceUrl}individual/mandate/${params.id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
